import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-legal',
  templateUrl: './footer-legal.component.html',
  styleUrls: ['./footer-legal.component.css']
})
export class FooterLegalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
